import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { TransactionProvider } from './context/TransactionContext';



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <TransactionProvider>
      <App />
    </TransactionProvider>
  </React.StrictMode>
);

